import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const reminder = async (id?: number, type?: "task") => {
  const qs = type ? "?type=task" : "";
  return axios.get(Routes.REMINDER + "/" + id + qs);
};

export const useReminder = (params: { id?: number; type?: "task" }) => {
  const { id, type } = params;
  return useQuery({
    queryKey: [Keys.REMINDER_QRY, id, type],
    queryFn: () => reminder(id, type),
    enabled: id ? true : false,
  });
};
